export const cartTypes = {
    ADD_ITEM: "CART_ADD_ITEM",
    EDIT_ITEM: "CART_EDIT_ITEM",
    REMOVE_ITEM: "CART_REMOVE_ITEM",
    CLEAR: "CART_CLEAR",
    SET_ORDER_ID: "CART_SET_ORDER_ID",
    SET_INTEGRATION_ID: "CART_SET_INTEGRATION_ID"
}